<template>
    <div :class="{ 'hovered': hovered }"
        v-b-hover="handleHoverChanged"
        @touchstart="handleHoverChanged(true)"
        @touchend="handleHoverChanged(false)"
    >
        <slot :hovered="hovered" />
    </div>
</template>

<script>
    import { VBHover } from 'bootstrap-vue';

    export default {
        data() {
            return {
                hovered: false,
            }
        },
        methods: {
            handleHoverChanged(hovered) {
                this.hovered = hovered;
            },
        },
        directives: {
            'b-hover': VBHover,
        },
    }
</script>